import React from "react";

export default function PageHeader({ title, description, action, overline }) {
  return (
    <div className="mb-6 md:mb-8 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3 animate-fade-up">
      <div>
        {overline && (
          <div className="text-[11px] uppercase tracking-[0.18em] font-semibold text-blue-600 dark:text-blue-400 mb-2">
            {overline}
          </div>
        )}
        <h1 className="font-display text-3xl sm:text-4xl font-bold tracking-tight">{title}</h1>
        {description && <p className="mt-1.5 text-sm text-muted-foreground max-w-2xl">{description}</p>}
      </div>
      {action && <div className="flex items-center gap-2">{action}</div>}
    </div>
  );
}

export const Card = ({ children, className = "", interactive, ...rest }) => (
  <div className={`surface ${interactive ? "surface-hover" : ""} ${className}`} {...rest}>{children}</div>
);

export const Pill = ({ children, className = "" }) => (
  <span className={`chip ${className}`}>{children}</span>
);
